import { Button, Popover } from "@shltelemedicine/shl-ui-lib";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import supportMenuIcon from "../../assets/nav/menu_support.svg";
import {
  MainContextActionType,
  useMainContext,
} from "../../context/MainContext";
import { useMainRoutes } from "../../hooks/useMainRoutes";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const { dispatch } = useMainContext();

  const { links } = useMainRoutes();

  const handleShowSupportModal = () =>
    dispatch({
      type: MainContextActionType.SET_SHOW_SUPPORT,
      payload: { show: true },
    });

  return (
    <nav className={`${styles.nav} h-100 d-flex`}>
      {links.map((l) => (
        <Popover
          key={l.to}
          id={l.to}
          hoverContent={<FormattedMessage id={l.label} defaultMessage={l.to} />}
        >
          <NavLink
            key={l.to}
            to={l.to}
            onClick={l.onCLick}
            className={({ isActive }) =>
              `${styles.menuLink} ${isActive ? styles.activeLink : ""}`
            }
          >
            <img className={`${styles.menuIcon} m-auto`} src={l.icon} alt="" />
          </NavLink>
        </Popover>
      ))}
      <Popover
        id={"support"}
        hoverContent={<FormattedMessage id={"NAV.SUPPORT"} />}
      >
        <Button
          variant=""
          className={`${styles.menuLink} d-inline-flex`}
          onClick={handleShowSupportModal}
        >
          <img className={styles.menuIcon} src={supportMenuIcon} alt="" />
        </Button>
      </Popover>
    </nav>
  );
};
export default Navbar;
